import type { ServerResponse } from 'node:http'

/** Thousands separators without relying on the runtime locale, so server and browser render the same text. */
export const formatCount = (value: number): string => {
    return String(Math.max(0, Math.round(value))).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const plural = (count: number, singular: string, pluralForm = `${singular}s`): string => {
    return `${formatCount(count)} ${count === 1 ? singular : pluralForm}`
}

/** Lets the published site serve a page from the edge for a minute; the preview always renders fresh. */
export const setPageCache = (res: ServerResponse): void => {
    if (process.env.NODE_ENV === 'production') res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=600')
}

export const firstParam = (value: string | string[] | undefined): string | null => {
    const raw = Array.isArray(value) ? value[0] : value

    return typeof raw === 'string' && raw.trim().length ? raw.trim() : null
}

export const pageParam = (value: string | string[] | undefined): number => {
    const page = Number(firstParam(value) ?? 1)

    return Number.isFinite(page) && page >= 1 ? Math.min(Math.floor(page), 1000) : 1
}
